import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../../../css/home.css';
import { url } from '../../../js/api/endpoint';
import language from '../../../js/stores/language.js';
import carFeatureLibrary from '../../../js/controllers/car-feature-lib.js';
var CarCard = function CarCard(props, _ref) {
  var $h = _ref.$h,
    $el = _ref.$el,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          $update();
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var goDisplay = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var anchor, carId, CarItem, obj, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            e.preventDefault();
            anchor = e.target.closest("a");
            carId = anchor.dataset.carId;
            CarItem = props.list.filter(function (item) {
              return item.CarId == carId;
            })[0];
            obj = {
              props: {}
            };
            obj.props.CarMainData = CarItem;
            _context2.next = 1;
            return carFeatureLibrary.getLocalizedData(carId, 1);
          case 1:
            obj.props.CarFeatureList = _context2.sent;
            _context2.next = 2;
            return carFeatureLibrary.getLocalizedData(carId, 2);
          case 2:
            obj.props.CarUseRestrictionList = _context2.sent;
            _context2.next = 3;
            return carFeatureLibrary.getLocalizedData(carId, 3);
          case 3:
            obj.props.CarPenaltyUseList = _context2.sent;
            $f7.views.main.router.navigate('/car-display/', obj);
            _context2.next = 5;
            break;
          case 4:
            _context2.prev = 4;
            _t = _context2["catch"](0);
            console.error(_t);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 4]]);
    }));
    return function goDisplay(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="stack-content">
${props.list.length > 0 && $h`
${props.list.map((item) => $h`
  <div class="card sub-item">
    <div class="card-header">
      ${item.CarManufacturerName} ${item.CarModel} ${item.CarYear} <br />
    </div>
    <div class="card-content card-content-padding text-align-center">
      <a class="link" href="#" @click="${goDisplay}" data-car-id="${item.CarId}">
        <img width="284" height="160" class="" src="${url}/${item.FilePath}/${item.FileName}" />
      </a>
    </div>
    <div class="card-footer">
      <span><i class="icon material-symbols-outlined color-lime">location_on</i> ${item.ContactLocalityName}, ${item.ContactProvinceName}</span>
      <span><i class="icon material-symbols-outlined color-lime">euro</i> ${locale.translate('general.from')} € ${item.CarPriceRent} ${locale.translate('general.perDay')}</span>
    </div>
  </div>
`)}
`}
</div>
`
    }
    ;
};
export default CarCard;